import React from 'react';
import { Button, notification, Alert } from 'antd';

import { Formik } from 'formik';
import { Form, FormItem, Input } from 'formik-antd';

import { useHistory } from 'react-router-dom';

import Client from 'containers/app/client';
import { LayoutPage } from 'components/layouts';

import './style.css';

import * as Yup from 'yup';

const successNotification = {
  message: 'Password reset link sent!',
  description: 'Check your inbox and follow the instructions.',
};

const schema = Yup.object().shape({
  email: Yup.string()
    .email('Invalid email')
    .required('Required'),
});

const initialValues = { email: '' };

const ForgotPassword = () => {
  const history = useHistory();
  const handleSubmit = async (values, actions) => {
    try {
      const { email } = values;
      await Client.passwordReset(email);
      actions.setSubmitting(false);
      notification.success(successNotification);
      history.push('/');
    } catch (e) {
      actions.setSubmitting(false);
      actions.setStatus({ message: e.message, type: 'error' });
    }
  };

  return (
    <LayoutPage className="forgot-password-page">
      <LayoutPage.Container className="wrapper">
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          validationSchema={schema}
        >
          {({ isSubmitting, status, setStatus }) => {
            return (
              <Form layout="vertical" className="wrapper">
                {status ? (
                  <Alert
                    closable
                    message={status.message}
                    type={status.type}
                    onClose={() => {
                      setStatus(undefined);
                    }}
                  />
                ) : null}
                <FormItem label="E-mail" name="email">
                  <Input name="email" />
                </FormItem>
                <Button
                  type="primary"
                  htmlType="submit"
                  disabled={isSubmitting}
                  loading={isSubmitting}
                >
                  Reset My Password
                </Button>
              </Form>
            );
          }}
        </Formik>
      </LayoutPage.Container>
    </LayoutPage>
  );
};

ForgotPassword.propTypes = {};

export default ForgotPassword;
